import qs from 'query-string';
import { get, post, put, del } from '../baseApi';

export const InvoiceApi = {
    fetch: (query) => get(`/admin/invoices?${qs.stringify(query)}`),
    fetchById: (id) => get(`/admin/invoices/${id}`),
    create: (data) => post('/admin/invoices', data),
    update: (id, data) => put(`/admin/invoices/${id}`, data),
    delete: (id) => del(`/admin/invoices/${id}`),
};
